package pl.decks.chartjs.radar.builder

import pl.decks.chartjs.radar.RadarConfig
import pl.decks.chartjs.radar.options.RadarOptions
import pl.decks.chartjs.radar.options.plugins.RadarPluginOptions
import pl.decks.chartjs.style.ChartLabel

@RadarDsl
class RadarConfigBuilder(
    private val labels: List<ChartLabel>,
) {
    private val datasets = mutableListOf<RadarDataSetBuilder>()
    private var scaleScope: ScaleScope? = null
    private var animationScope: AnimationScope? = null
    private var interactionScope: InteractionScope? = null
    private var legendScope: LegendScope? = null
    private var tooltipScope: TooltipScope? = null
    private var layoutScope: LayoutScope? = null
    var responsive: Boolean = true
    var maintainAspectRatio: Boolean = true

    fun addDataset(
        label: String,
        data: List<Number>,
        block: RadarDataSetBuilder.() -> Unit = {},
    ) {
        datasets.add(RadarDataSetBuilder(label, data).apply(block))
    }

    fun scale(block: ScaleScope.() -> Unit) {
        scaleScope = ScaleScope().apply(block)
    }

    fun animation(block: AnimationScope.() -> Unit) {
        animationScope = AnimationScope().apply(block)
    }

    fun interaction(block: InteractionScope.() -> Unit) {
        interactionScope = InteractionScope().apply(block)
    }

    fun legend(block: LegendScope.() -> Unit) {
        legendScope = LegendScope().apply(block)
    }

    fun tooltip(block: TooltipScope.() -> Unit) {
        tooltipScope = TooltipScope().apply(block)
    }

    fun layout(block: LayoutScope.() -> Unit) {
        layoutScope = LayoutScope().apply(block)
    }

    internal fun build() = RadarConfig(
        labels = labels,
        datasets = datasets.map { it.build() },
        options = RadarOptions(
            responsive = responsive,
            maintainAspectRatio = maintainAspectRatio,
            animation = animationScope?.build(),
            interaction = interactionScope?.build(),
            scale = scaleScope?.build(),
            plugins = RadarPluginOptions(
                legend = legendScope?.build(),
                tooltip = tooltipScope?.build(),
            ).takeIf { legendScope != null || tooltipScope != null },
            layout = layoutScope?.build(),
        ),
    )
}
